import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { RequestService } from '../request';
import { Export } from './defs';

@Injectable({
  providedIn: 'root',
})
export class ExportsService {
  constructor(private request: RequestService) {}

  public getList(): Observable<Export[]> {
    return this.request.get('/api/export/');
  }

  public delete(id: number): Observable<any> {
    return this.request.delete(`/api/export/${id}`);
  }

  public deleteMany(ids: number[]): Observable<any> {
    return forkJoin(ids.map((id) => this.delete(id)));
  }

}
